/**
 * Component: M6 Resources
 * 
 */
'use strict';

export class Resources
{
  constructor()
  {
    this.selectors = {
      component: $('.c-v4-m6-resources'),
      cards:     $('.c-v4-m6-resources .c-v4-m6-resources--main-card > a'),
      slider:    $('.c-v4-m6-resources .slick-slider')
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.init_slick_carousel();
  }

  /**
   * Init slick carousel
   * 
   */
  init_slick_carousel()
  {
    this.selectors.component.each(function()
    {
      let _childElements = $(this).find('.c-resource-card').children().length;

      $(this).find('.slick-slider').slick({
        arrows:         false,
        autoplay:       false,
        dots:           false,
        pauseOnHover:   false,
        slidesToScroll: 1,
        slidesToShow:   _childElements,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              variableWidth: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow:   1,
              dots:           true,
              variableWidth: true
            }
          },
        ]
      });
    });
  }
}
